module.exports = __webpack_public_path__ + "static/media/Home-Banner.ac989389.jpg";